import Temp from "@/courier/Temp";

export default class FlashExpress extends Temp {
  static CODE = "FLE";

  constructor() {
    super(FlashExpress.CODE);
  }

  listPostcodeSpecial = JSON.parse(localStorage.getItem("courier_postcode"));

  static TYPE_SAME_PROVINCE_NOT_BKK = "SAME_PROVINCE_NOT_BKK";
  static RULE_DIMENSION_WEIGHT = {
    SAME_PROVINCE_NOT_BKK: {
      max_weight: 19001,
      max_dimension: 220,
    },
  };

  async getZone(item, courier) {
    // replace ทุ่งปี๊ -> ทุ่งปี้ เพราะ address flash ใช้ปี้ เกิดมาเพื่อน้องแฟลชคนเดียว
    if (item.to.state == 'ทุ่งปี๊') {
      item.to.state = 'ทุ่งปี้';
    }
  
    let type, from, to;
    let cross_price = 0;
    let remote_area = 0;
    let travel_surcharge = 0;
    let island_surcharge = 0;
    let fuel_surcharge = 0;

    remote_area = super.checkRemoteArea(Number(item.toPostcode));
    travel_surcharge = super.checkTravelSurcharge(Number(item.toPostcode));
    island_surcharge = super.checkIslandSurcharge(Number(item.toPostcode));
    if (travel_surcharge) {
      if (new Date().getTime() > new Date('2023-04-08 00:00:00').getTime()) {
        if (item.weight > 20000) {
          travel_surcharge = 200;
        } else if (item.weight > 7000) {
          travel_surcharge = 100;
        } else {
          travel_surcharge = 30;
        }
      } else {
        if (item.weight > 50000) {
          travel_surcharge = 150;
        } else if (item.weight > 30000) {
          travel_surcharge = 100;
        } else {
          travel_surcharge = 50;
        }
      }
    }
    let prefixFromPostCode = item.fromPostcode.toString().substring(0, 2);
    let prefixToPostCode = item.toPostcode.toString().substring(0, 2);

    // เฉพาะตอนโปร 9.9 FLE ถึง 27/12/2020
    if (Object.keys(item.courierRates).length < 2) {
      from = null;
      to = null;
    } else {
      from = super.checkZone(prefixFromPostCode);
      to = super.checkZone(prefixToPostCode);
    }
    if (["94", "95", "96"].indexOf(prefixToPostCode) > -1) {
      remote_area = this.listPostcodeSpecial[FlashExpress.CODE].remotearea
        .special.cost;
    }

    if (
      ["94", "95", "96"].indexOf(prefixToPostCode) > -1 &&
      ["94", "95", "96"].indexOf(prefixFromPostCode) > -1
    ) {
      remote_area = 0;
    }
    const sameProvince = this.checkSameProvince(item);
    // 1 = กทม. BKK
    // 2 = ภาคกลาง C
    // 3 = เหนือ N
    // 4 = ภาคอีสาน NE
    // 5 = ภาคใต้ S
    // console.log('same province', sameProvince);
    if ([3, 4, 5, 2].includes(to) && to === from && sameProvince) {
      if (to == 3) type = 8;
      if (to == 4) type = 9;
      if (to == 5) type = 10;
      if (to == 2) type = 11;
    } else if (from == 1 && to == 1) {
      // BKK -> BKK
      type = 1;
    } else if (from == 1 && [3, 4, 5, 2].includes(to)) {
      // BKK -> N, NE, S, C
      type = 2;
    } else if ([3, 4, 5, 2].includes(from) && to == 1) {
      // N, NE, S, C -> BKK
      type = 3;
    } else if (from == 3 && [3, 4, 5, 2].includes(to)) {
      // N -> N, NE, S, C
      type = 4;
    } else if (from == 4 && [3, 4, 5, 2].includes(to)) {
      // NE -> N, NE, S, C
      type = 5;
    } else if (from == 5 && [3, 4, 5, 2].includes(to)) {
      // S -> N, NE, S, C
      type = 6;
    } else if (from == 2 && [3, 4, 5, 2].includes(to)) {
      // C -> N, NE, S, C
      type = 7;
    }

    let fuel_surcharge_data = await super.getFuelSurcharge()

    if (fuel_surcharge_data) {
      const temp = {
        1: 'BKK-BKK',
        2: 'BKK-NNESC',
        3: 'NNESC-BKK',
        4: 'N',
        5: 'NE',
        6: 'S',
        7: 'C',
        8: 'SAMEN',
        9: 'SAMENE',
        10: 'SAMES',
        11: 'SAMEC'
      }

      fuel_surcharge = fuel_surcharge_data[temp[type]] ? fuel_surcharge_data[temp[type]] : 0;
    }

    return {
      rate_type: type,
      rate_remote_area: remote_area,
      travel_surcharge: travel_surcharge,
      island_surcharge: island_surcharge,
      cross_price: cross_price,
      fuel_surcharge
    };
  }
  checkRuleDimensionWeight(type, item) {
    const rule = FlashExpress.RULE_DIMENSION_WEIGHT[type]
      ? FlashExpress.RULE_DIMENSION_WEIGHT[type]
      : false;
    if (!rule) return rule;
    return (
      +item.weight < rule.max_weight && +item.culculateSize < rule.max_dimension
    );
  }
  checkSameProvince(item) {
    const replaceProvincePattern = new RegExp(/[^ก-๙\-]/g);
    return (!item.source && (item.province.sameData == item.province.to.replace(replaceProvincePattern, ''))) ||
      (item.source && (item.province.from == item.province.to.replace(replaceProvincePattern, '')));
  }
  checkWeight(courierRates, item, validate) {
    if (!courierRates) return { index: -1 };
    item.index = courierRates.findIndex((rate) => {
      return item.weight >= rate.min && item.weight <= rate.max;
    });
    return super.checkRules(item, validate);
  }

  checkDimension(dimensionCourier, item, validate) {
    return super.checkCourierDimension(dimensionCourier, item, validate);
  }

  calculateExtraTravel(selectedTier) {
    let travel_surcharge = 0;

    if (selectedTier.max > 20000) {
      travel_surcharge = 200;
    } else if (selectedTier.max > 7000) {
      travel_surcharge = 100;
    } else {
      travel_surcharge = 30;
    }
    
    return travel_surcharge;
  }
  async checkRemoteAreaByCorrectorDest(addressRemote, option) {
    return new Promise((resolve) => {
      super.getArea([addressRemote], ["FLE"], option).then((res) => {
        let weight = option.weight;
        if (weight < ((option.price && option.price.selectedTier) ? option.price.selectedTier.max : 0)) {
          weight = option.price.selectedTier.max
        }
        let returnRate = {
          isRemote: res.data.FLE?(res.data.FLE.is_remote?50:0):0,
          isTravelArea: 0,
          isIsland: res.data.FLE?(res.data.FLE.is_island?30:0):0
        };
          
        if (res.data && res.data.FLE && res.data.FLE.is_tourist) {
          if (weight > 20000) {
            returnRate.isTravelArea = 200;
          } else if (weight > 7000) {
            returnRate.isTravelArea = 100;
          } else {
            returnRate.isTravelArea = 30;
          }
        }
        
        resolve(returnRate);
      });
    });
  }
}
